import {
  ChoicePanel,
  Skeleton,
  Stack,
  tokens,
  Typography,
  Icons,
} from '@cast/design-system';

type PresetCardProps = {
  icon: typeof Icons.Scales;
  title: string;
  description: string;
  selected: boolean;
  selectable?: boolean;
  disabled?: boolean;
  onClick: () => void;
  testId: string;
};

const MIN_HEIGHT = 128;

export const PresetCard = ({
  icon: Icon,
  title,
  description,
  selected,
  disabled,
  onClick,
  testId,
}: PresetCardProps) => {
  return (
    <ChoicePanel
      selected={selected}
      disabled={disabled}
      onClick={onClick}
      testId={testId}
      sx={{
        minHeight: MIN_HEIGHT,
        p: 16,
      }}
    >
      <Stack
        gap={8}
        color={disabled && !selected ? tokens.theme.disabled.fg : undefined}
      >
        <Icon size={24} />
        <Stack gap={4}>
          <Typography variant="A1">{title}</Typography>
          <Typography variant="P12R">{description}</Typography>
        </Stack>
      </Stack>
    </ChoicePanel>
  );
};

const PresetCardSkeleton = () => {
  return <Skeleton height={MIN_HEIGHT} />;
};

PresetCard.Skeleton = PresetCardSkeleton;
